import { Link } from "react-router-dom";
import ContactBlock from "@/components/common/ContactBlock";

export default function Footer() {
  return (
    <footer className="bg-ink text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <h2 className="text-3xl sm:text-5xl font-light tracking-tight text-neutral-100 max-w-2xl leading-tight">
          Have you lived through a transplant journey?
        </h2>
        <Link
          to="/share"
          data-testid="footer-share-cta"
          className="inline-flex items-center mt-8 bg-white text-ink px-6 py-3 text-sm font-medium hover:bg-rust hover:text-white transition-colors"
        >
          Share your journey
        </Link>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mt-20 pt-12 border-t border-neutral-800">
          <div>
            <div className="flex items-center gap-2.5">
              <img src="/assets/logo-mark.png" alt="Transplant Story" className="h-8 w-auto" />
              <span className="font-bold tracking-tight">TRANSPLANT STORY</span>
            </div>
            <p className="text-sm text-neutral-400 mt-2">Real stories. Real experiences.</p>
          </div>
          <div className="space-y-2 text-sm">
            <div className="text-[11px] font-mono uppercase tracking-widest text-neutral-500 mb-2">Explore</div>
            <Link to="/explore" className="block text-neutral-300 hover:text-white transition-colors">Explore Journeys</Link>
            <Link to="/share" className="block text-neutral-300 hover:text-white transition-colors">Share Your Journey</Link>
            <Link to="/centres" className="block text-neutral-300 hover:text-white transition-colors">Transplant Centers</Link>
            <Link to="/about" className="block text-neutral-300 hover:text-white transition-colors">About</Link>
            <Link to="/feedback" data-testid="footer-feedback-link" className="block text-neutral-300 hover:text-white transition-colors">Send Feedback</Link>
          </div>
          <div>
            <div className="text-[11px] font-mono uppercase tracking-widest text-neutral-500 mb-3">Contact</div>
            <ContactBlock dark />
          </div>
          <div className="space-y-2 text-sm">
            <div className="text-[11px] font-mono uppercase tracking-widest text-neutral-500 mb-2">Legal</div>
            <Link to="/privacy" className="block text-neutral-300 hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="block text-neutral-300 hover:text-white transition-colors">Terms</Link>
            <Link to="/guidelines" className="block text-neutral-300 hover:text-white transition-colors">Community Guidelines</Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-neutral-800 text-[11px] font-mono text-neutral-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Transplant Story</span>
          <span>We don't tell you where to go. We help you understand what is there.</span>
        </div>
        <div className="mt-5 text-[11px] font-mono text-neutral-600">
          Powered by Comprehensive Organ Transplant Care Pvt. Ltd.
        </div>
      </div>
    </footer>
  );
}
